// extracted by mini-css-extract-plugin
module.exports = {"SecArticleMain":"SecArticleMain_SecArticleMain__3mE1K"};